module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-2-3f6b5ffb4b94b89b65371ffa3765c009.jpg";